import {Button, Col, Divider, Form, Input, Radio, Row, Select, Typography} from "antd";
import {validateMessages} from "../../app/util";
import {RequiredTitle} from "../piece/common";

const {Option} = Select
const {Title, Text} = Typography
const {TextArea} = Input

export default (props) => {
    // Return JSX of the first step view
    return (
        <>
            <main>
                <Form
                    olon={false}
                    ref={props.formRef}
                    labelAlign='left'
                    layout={'vertical'}
                    onFinish={props.onFinish}
                    validateMessages={validateMessages}
                    onFinishFailed={props.onFinishFailed}
                >
                    <div style={{marginLeft: '20%', marginRight: '20%', marginTop: "1%"}}>

                          {props.hasStatement && (
                            <Row style={{marginTop: '32px'}}>
                                <Col xs={24}>
                                    <Form.Item
                                        label={"Statement"}
                                        name='response'
                                        style={{paddingBottom: 4}}
                                        rules={[
                                            {
                                                required: false,
                                                type: 'string',
                                                max: 10000,
                                                min: 0
                                            }
                                        ]}
                                    >
                                        <TextArea rows={36} />
                                    </Form.Item>
                                </Col>

                                 <Col xs={24}>
                                    <Form.Item
                                        label={"Any Comments?"}
                                        name='comments'
                                        style={{paddingBottom: 4}}
                                        rules={[
                                            {
                                                required: false,
                                                type: 'string',
                                                max: 2000,
                                                min: 0
                                            }
                                        ]}
                                    >
                                        <TextArea rows={4}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}

                         {!props.newStatement && (
                            <Row>
                                <Button style={{float: 'right', marginTop: '12px', width: '100%'}} type='primary' htmlType={"submit"}
                                        size='middle'>
                                    Regenerate the Statement
                                </Button>
                                <Divider/>
                            </Row>
                        )}


                        <Row gap={5} style={{flexDirection: 'row', gap: '24px', marginTop: '8%'}}>
                            <Col md={7} sm={11} xs={24}>
                                <Form.Item
                                    label={"Word Limit"}
                                    name='wordLimit'
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: false,
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            </Col>
                            <Col md={7} sm={11} xs={24}>
                                <Form.Item
                                    label={"Language"}
                                    name='language'
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: true,
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Select>
                                        <option value='English'>English</option>
                                        <option value='Spanish'>Spanish</option>
                                        <option value='Mandarin'>Mandarin</option>
                                        <option value='French'>French</option>
                                        <option value='German'>German</option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={8} sm={11} xs={24}>
                                <Form.Item
                                    label={"Tone"}
                                    name='tone'
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: false,
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Radio.Group>
                                        <Radio value='formal'>Formal</Radio>
                                        <Radio value='casual'>Casual</Radio>
                                        <Radio value='narrative-style'>Narrative</Radio>
                                        <Radio value='analytical'>Analytical</Radio>
                                        <Radio value='poetic'>Poetic</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider/>

                        <Row gap={5}>
                            <Col>
                                <Form.Item
                                    name='name'
                                    label={RequiredTitle('What\'s your name?')}
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: true,
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item
                                    name='place'
                                    label={'Where do you live?'}
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: false,
                                            type: 'string',
                                            max: 100,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gap={5}>
                            <Col>
                                <Form.Item
                                    name='inspiration'
                                    label={'What inspired you to become an artist?'}
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: false,
                                            type: 'string',
                                            max: 2000,
                                            min: 1
                                        }
                                    ]}
                                >
                                    <TextArea rows={4}/>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item
                                    name='emotion'
                                    label={'What message or emotion do you hope to convey?'}
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: false,
                                            type: 'string',
                                            max: 2000,
                                            min: 0
                                        }
                                    ]}
                                >
                                    <TextArea rows={4}/>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gap={5}>
                            <Col>
                                <Form.Item
                                    name='challenges'
                                    label={'What challenges have you faced in your artistic career?'}
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: false,
                                            type: 'string',
                                            max: 2000,
                                            min: 0
                                        }
                                    ]}
                                >
                                    <TextArea rows={4}/>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Form.Item
                                    name='accomplishments'
                                    label={'What accomplishments are you most proud of as an artist?'}
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: false,
                                            type: 'string',
                                            max: 2000,
                                            min: 0
                                        }
                                    ]}
                                >
                                    <TextArea rows={4}/>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gap={5}>
                            <Col>
                                <Form.Item
                                    label={"Which keyword(s) should appear in your statement?"}
                                    name='keywords'
                                    style={{paddingBottom: 4}}
                                    rules={[
                                        {
                                            required: false,
                                            type: 'string',
                                            max: 2000,
                                            min: 0
                                        }
                                    ]}
                                >
                                    <TextArea rows={4}/>
                                </Form.Item>
                            </Col>
                        </Row>

                        {props.newStatement && (
                            <Row>
                                <Button style={{float: 'right', marginTop: '64px', width: '100%'}} type='primary' htmlType={"submit"}
                                        size='middle'>
                                    Write the Statement
                                </Button>
                            </Row>
                        )}


                    </div>
                </Form>
            </main>
        </>
    );
};